<template>
  <v-row justify="center" align="center">
    <v-col cols="12" md="12" sm="12">
      <v-banner icon="settings">Settings</v-banner>
    </v-col>
    <v-col cols="12" md="12" sm="12">
      <v-banner>Product Settings</v-banner>
      <ProductCodeToggle />
      <ProductSynonymToggle />
      <ProductCountryToggle />
      <ProductQtyInBoxToggle />
      <ProductFiltersToggle />
      <ProductViewToggle v-if="showProdViewToggle" />
    </v-col>

    <v-col cols="12" md="12" sm="12">
      <v-banner>Other Settings</v-banner>
      <ShowMenuToggle></ShowMenuToggle>
      <InstallPromptShow></InstallPromptShow>
    </v-col>

    <v-col cols="12" md="12" sm="12">
      <v-banner>Experimental Settings</v-banner>
      <DashboardToggle v-if="showDashboardToggle" />
      <ThemeToggle v-if="showThemeToggle"></ThemeToggle>
      <CustomTheme v-if="showCustomTheme"></CustomTheme>
    </v-col>
  </v-row>
</template>

<script>
import ThemeToggle from "@/components/customisation/ThemeToggle.vue";
import DashboardToggle from "@/components/customisation/DashboardToggle.vue";

import ProductViewToggle from "@/components/customisation/ProductViewToggle.vue";
import ProductCodeToggle from "@/components/customisation/ProductCodeToggle.vue";
import ProductSynonymToggle from "@/components/customisation/ProductSynonymToggle.vue";
import ProductQtyInBoxToggle from "@/components/customisation/ProductQtyInBoxToggle.vue";

import ProductCountryToggle from "@/components/customisation/ProductCountryToggle.vue";
import ProductFiltersToggle from "@/components/customisation/ProductFiltersToggle.vue";

import ShowMenuToggle from "@/components/customisation/ShowMenuToggle.vue";

import InstallPromptShow from "@/components/customisation/InstallPromptShow.vue";
import CustomTheme from "@/components/customisation/CustomTheme.vue";

export default {
  name: "Account",
  components: {
    ProductViewToggle,
    ThemeToggle,
    DashboardToggle,
    ProductCodeToggle,
    ProductSynonymToggle,
    ProductQtyInBoxToggle,
    ProductCountryToggle,
    ProductFiltersToggle,
    ShowMenuToggle,
    InstallPromptShow,
    CustomTheme,
  },
  data: () => ({
    showDashboardToggle: false,
    showProdViewToggle: false,
    showThemeToggle: true,
    showCustomTheme: false,
  }),
};
</script>

<style lang="scss" scoped>
</style>